import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/NBORDERCROSS/general";
import TODIS_FORM_OPS from "./form/NBORDERCROSS/operations";
import TODIS_FORM_INFRA from "./form/NBORDERCROSS/infrastructure";
import TODIS_FORM_REILBORDEROPER from "./form/NBORDERCROSS/rbordercrossoper";
import "react-datepicker/dist/react-datepicker.css";

const TODIS_FORM_BORDERCROSS = ({ errors, touched, status }) => {
    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="General" title="General" >
                <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" />
            </Tab>
            <Tab eventKey="RailBorderOper" title="Rail Border Cross Operation">
                <TODIS_FORM_REILBORDEROPER errors={errors} touched={touched} disabled={status} TypeForm="" />
            </Tab>     
        </Tabs>
    )
}
export default TODIS_FORM_BORDERCROSS;